import { Breadcrumb, Layout, Menu } from 'antd'
import {
  UserOutlined,
  HomeOutlined,
  PictureOutlined,
  ProjectOutlined,
  GoldOutlined,
  ReadOutlined,
  KeyOutlined,
  BuildOutlined,
  HighlightOutlined,
  DollarCircleOutlined,
  MessageOutlined,
} from '@ant-design/icons'
import studioLogo from '../../assets/newStudioLogo.png'
import React, { useState } from 'react'
import { Homepage, UserManage } from '../index'
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom'
import './index.css'
import MainHeader from './components/mainHeader/mainHeader'
import { useEffect } from 'react'

export default function WexonLayout() {
  const { Header, Content, Footer, Sider } = Layout
  const navigate = useNavigate()
  const location = useLocation()
  // console.log(location)
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    }
  }

  const changeItem = (to) => {
    navigate(to)
  }

  const items = [
    getItem('首页', '/homepage', <HomeOutlined />),
    getItem('用户管理', '/userManage', <UserOutlined />),
    getItem('轮播图管理', '/swiperManage', <PictureOutlined />),
    getItem('房源管理', '/houseManage', <ProjectOutlined />),
    getItem('活动管理', '/eventManage', <BuildOutlined />),
    getItem('闲置二手', '/secondHand', <DollarCircleOutlined />),
    getItem('25fall抱团', '/fallGroup', <MessageOutlined />),
    getItem('租房必看', '/rentReadme', <HighlightOutlined />),

    getItem('论坛管理', '/', <GoldOutlined />, [
      getItem('帖子管理', '/postManage'),
      getItem('评论管理', '/commentManage'),
    ]),
    getItem('内容管理', '/content', <ReadOutlined />, [
      getItem('学业分享管理', '/studyManage', <ReadOutlined />),
      getItem('留学攻略管理', '/beforeTravelManage', <ReadOutlined />),
    ]),
    getItem('成员管理', '/memberManage', <KeyOutlined />),
  ]

  //在编辑详情页面不显示footer
  const [isShowFooter, setIsShowFooter] = useState(true)
  useEffect(() => {
    if (
      location.pathname === '/newContent' ||
      location.pathname === '/newHouse'
    ) {
      setIsShowFooter(false)
    } else {
      setIsShowFooter(true)
    }
  }, [location.pathname])
  return (
    <Layout hasSider>
      <Sider
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          background: 'rgba(0, 39, 102, 1)',
          boxShadow: '2px 2px 2px #C8CDD1',
        }}
      >
        <div className="logo" />
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[`${location.pathname}`]}
          items={items}
          onClick={(e) => {
            changeItem(e.key)
            if (e.key === '/studyManage') {
              localStorage.setItem('contentType', 1)
            } else if (e.key === '/rentManage') {
              localStorage.setItem('contentType', 2)
            } else if (e.key === '/beforeTravelManage') {
              localStorage.setItem('contentType', 3)
            }
          }}
          style={{
            background: 'rgba(0, 39, 102, 1)',
          }}
        />
      </Sider>
      <Layout
        className="site-layout"
        style={{
          marginLeft: 200,
        }}
      >
        <Header
          className="site-layout-sub-header-background"
          style={{ padding: 0, backgroundColor: 'white', height: '96px' }}
        >
          <MainHeader />
        </Header>
        <Content
          style={{
            // overflow: 'initial',
            background: 'rgba(0, 39, 102, 1)',
          }}
        >
          <div
            className="site-layout-background"
            style={{
              padding: 24,
              textAlign: 'center',
            }}
          >
            <Outlet />
          </div>
          {isShowFooter ? (
            // <Footer
            //   style={{
            //     textAlign: 'center',
            //   }}
            // >
            <div className="layoutFooter">
              <img className="studioLogo " src={studioLogo} alt="studioLogo" />
              <div
                className="version"
                style={{ marginTop: '4vh', color: 'grey' }}
              >
                当前版本:1.6.3.241204
              </div>
            </div>
          ) : // </Footer>
          null}
        </Content>
        {/* {isShowFooter ? (
          <Footer
            style={{
              textAlign: 'center',
            }}
          >
            <div className="layoutFooter">
              <img className="studioLogo " src={studioLogo} alt="studioLogo" />
            </div>
          </Footer>
        ) : null} */}
      </Layout>
    </Layout>
  )
}
